<template>
    <sections>
        <section-hero
            :heading="$config.public.siteName"
            content="<article-home />"
            :image="hero.image"
            :imageSet="hero.imageSet"
            :imageSizes="hero.imageSizes"
            buttonText="Contact Us"
            buttonRoute="/contact"
        ></section-hero>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const hero = {
    imageSizes: '(max-width: 983px) 100vw, 983px',
    imageSet: `
        ${$config.public.images}home-hero-200.webp 200w,
        ${$config.public.images}home-hero-488.webp 488w,
        ${$config.public.images}home-hero-699.webp 699w,
        ${$config.public.images}home-hero-879.webp 879w,
        ${$config.public.images}home-hero-983.webp 983w
    `,
    image: `${$config.public.images}home-hero.jpg`,
};

useSeo().buildHead({
    title: $config.public.siteName,
    description: $config.public.siteStrapline,
    index: true,
});
</script>
